import React, { Component } from 'react';

class Load extends Component {
  constructor() {
    super();
    this.state = {

    };
  }

  componentWillMount(){
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <h6 className="bg-primary text-light" align="center"><br/>Aguarde <i className="fas fa-spinner fa-spin"></i><br/><br/></h6>
          </div>
        </div>
      </div>
    );
  }
}

export default Load;
